import { Uuid } from '@belimo-retrofit-portal/logic';
import { Project } from 'src/modules/common/types/Project';
import { ProjectSettings } from 'src/modules/common/types/ProjectSettings';
import { ProjectViewData } from 'src/modules/project-view/types/ProjectViewData';
import { createTrigger } from 'src/utils/createTrigger';

export const PROJECT_VIEW_FETCH = createTrigger<ProjectViewData, Uuid>('PROJECT_VIEW_FETCH');
export const PROJECT_VIEW_RESET = createTrigger<void, Uuid>('PROJECT_VIEW_RESET');
export const PROJECT_VIEW_REPLACE = createTrigger<Project>('PROJECT_VIEW_REPLACE');
export const PROJECT_VIEW_SETTINGS = createTrigger<ProjectSettings, Uuid>('PROJECT_VIEW_SETTINGS');
export const PROJECT_VIEW_SHARE = createTrigger<Project>('PROJECT_VIEW_SHARE');
